<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import preventionbrigadeAPI from "@/services/standards/preventionbrigade/preventionbrigadeAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal"
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "5.1.2 Brigada de emergencias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "5.1.2 Brigada de emergencias",
      items: [

        {
          text: "Estandares",
          href: "/",
        },
        {
          text: "5.1.2 Brigada de emergencias",
          active: true,
        },
      ],
      lista: [],
      file: null,
      itemData: null,
      submitted: false,
      preventionbrigade: {
        file: "",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      loading: true,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/MATRIX_RISK.xlsx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },
    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.preventionbrigade.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/5.1.2/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/5.1.2/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.preventionbrigade.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getBrigade() {
      preventionbrigadeAPI
        .getBrigade(this.$route.params.id)
        .then((response) => {
          this.preventionbrigade = {
            file: response.file,
            companies_id: response.companies_id
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        preventionbrigadeAPI.updateBrigade(this.$route.params.id, {
          file: this.preventionbrigade.file,
          companies_id: this.preventionbrigade.companies_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 52,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No see ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getBrigade()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Elaborar acta de la conformación de la brigada de prevención, preparación y respuesta ante
                      emergencias e incluir en el ítem 1.2.1 la capacitación a este equipo. Entregar dotación para el
                      desempeño de sus funciones como son: Elementos de protección Personal, botiquines, extintores,
                      distintivos, entre otros.
                    </p>
                  </CheckModal>
                </div>
                <div class="col-6 text-right m-b-0">

                  <label for="">Formato ejemplo de acta de constitución brigadista</label>

                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Descargar formato ejemplo de acta de constitución brigadista
                  </b-tooltip>
                </div>
              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!allowAccess()" type="file" id="file" ref="file" name="file"
                      browse-text="Buscar"
                      :placeholder="preventionbrigade.file ? getFile(preventionbrigade.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label-for="input-sm">
                    <b-form-input type="text" hidden id="id" v-model="preventionbrigade.companies_id">
                    </b-form-input>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>